/**
 * @author Punit Vajpeyi <punit@wemotiveforge.com>
 */

import React from 'react';
import ReactTable from 'react-table';
import {connect} from 'react-redux';
import moment from 'moment';
import {setPageTitle} from "../../DashboardActions";
import './UserDashboard.css';
import {getAnalysis, getBillingSummary, getSummary, downloadSummaryReport} from "../../DashboardApiActions";
import {Card, Col, Row, Radio, Button, Typography, Tag, Input, Tooltip} from 'antd';
import {ACTIONS} from '../../../../utils/Constants';
import Notification from '../../../../utils/Notification';
import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";
import UtilHelper from "../../../../utils/UtilHelper";
import SummaryCard from './SummaryCard';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon';
import DataGrid from '../../../../utils/components/DataGrid/DataGrid'
const notification = new Notification(5)
const adminColumnDefs = [
  {
    headerName: 'Organization',
    field: 'name',
    cellRendererFramework: (params) => {
      return <Tooltip placement="topLeft" title={params.data.name}>{params.data.name}</Tooltip>
    }
  },
  {
    headerName: '# Users',
    field: 'totalNoOfUsers',
    valueGetter: params => Number(params.data.totalNoOfUsers),
  },
  {
    headerName: '# Active Users/Wk',
    field: 'activeUserslast1Week',
    valueGetter: params => Number(params.data.activeUserslast1Week),
  },
  {
    headerName: '# Active Users/4 Wks',
    field: 'activeUserslast4Weeks',
    valueGetter: params => Number(params.data.activeUserslast4Weeks),
  },
  {
    headerName: '# Cases',
    field: 'totalNoOfCases',
    valueGetter: params => Number(params.data.totalNoOfCases),
  },
  {
    headerName: '# Cases This Wk',
    field: 'noOfCasesThisWeek',
    valueGetter: params => Number(params.data.noOfCasesThisWeek),
  },
  {
    headerName: '# Cases Last Wk',
    field: 'noOfCasesLastWeek',
    valueGetter: params => Number(params.data.noOfCasesLastWeek),
  },
  {
    headerName: '# Cases This Month',
    field: 'noOfCasesThisMonth',
    valueGetter: params => Number(params.data.noOfCasesThisMonth),
  },
  {
    headerName: '# Cases This Year',
    field: 'noOfCasesThisYear',
    valueGetter: params => Number(params.data.noOfCasesThisYear),
  },
  {
    headerName: 'Last Case Created',
    field: 'lastCaseCreatedAt',
    getQuickFilterText: (params) => moment(params.data.lastCaseCreatedAt).format('DD/MM/YYYY'),
    valueGetter: (params) => UtilHelper.getReadableDuration(params.data.lastCaseCreatedAt) || '-',
  }
];

const adminColumns = [{
    Header: 'Organization', accessor: 'name', resizable: false, id: 'name',
    Cell: row => {
      return <span className={'case-table-case-name'}>
        {row.original.name}
      </span>
    }
  },
  {Header: '# Users', accessor: 'totalNoOfUsers', resizable: false},
  {
    Header: '# Active Users/Wk',
    accessor: d => Number(d.activeUserslast1Week),
    id: 'activeUserslast1Week',
    resizable: false
  },
  {
    Header: '# Active Users/4 Wks',
    accessor: d => Number(d.activeUserslast4Weeks),
    id: 'activeUserslast4Weeks',
    resizable: false
  },
  {
    Header: '# Cases',
    accessor: d => Number(d.totalNoOfCases),
    id: 'totalNoOfCases',
    resizable: false
  },
  {
    Header: '# Cases This Wk',
    accessor: d => Number(d.noOfCasesThisWeek),
    id: 'noOfCasesThisWeek',
    resizable: false
  },
  {
    Header: '# Cases Last Wk',
    accessor: d => Number(d.noOfCasesLastWeek),
    id: 'noOfCasesLastWeek',
    resizable: false
  },
  {
    Header: '# Cases This Month',
    accessor: d => Number(d.noOfCasesThisMonth),
    id: 'noOfCasesThisMonth',
    resizable: false
  },
  {
    Header: '# Cases This Year',
    accessor: d => Number(d.noOfCasesThisYear),
    id: 'noOfCasesThisYear',
    resizable: false
  },
  {
    Header: 'Last Case Created',
    accessor: d => d.lastCaseCreatedAt ? new Date(d.lastCaseCreatedAt).getTime() : 0,
    id: 'lastCaseCreatedAt',
    resizable: false,
    Cell: d => d.original.lastCaseCreatedAt ? new Date(d.original.lastCaseCreatedAt).toLocaleDateString('en-us') : '-'
  }];

const orgManagerColumnDefs = [
  {
    headerName: 'Email',
    field: 'email'
  },
  {
    headerName: 'Name',
    valueGetter: (params) => {
      const first = params.data.firstName || ''
      const last = params.data.lastName || ''
      return `${first} ${last}`.trim()
    }
  },
  {
    headerName: 'Total',
    // field: 'totalNoOfCases',
    valueGetter: params => Number(params.data.totalNoOfCases),
  },
  {
    headerName: 'This Week',
    // field: 'noOfCasesThisWeek',
    valueGetter: params => Number(params.data.noOfCasesThisWeek),
  },
  {
    headerName: 'Last Week',
    // field: 'noOfCasesLastWeek',
    valueGetter: params => Number(params.data.noOfCasesLastWeek),
  },
  {
    headerName: 'This Month',
    // field: 'noOfCasesThisMonth',
    valueGetter: params => Number(params.data.noOfCasesThisMonth),
  },
  {
    headerName: 'This Year',
    // field: 'noOfCasesThisYear',
    valueGetter: params => Number(params.data.noOfCasesThisYear),
  },
  {
    headerName: 'Last Case Created',
    field: 'lastCaseCreatedAt',
    valueGetter: (params) => UtilHelper.getReadableDuration(params.data.lastCaseCreatedAt) || '-',
  }
];

const orgManagerColumns = [{Header: 'Email', accessor: 'email', resizable: false},
  {Header: 'First Name', accessor: 'firstName', resizable: false},
  {Header: 'Last Name', accessor: 'lastName', resizable: false},
  {Header: 'Total', accessor: 'totalNoOfCases', resizable: false},
  {
    Header: 'This Week',
    accessor: d => Number(d.noOfCasesThisWeek),
    id: 'noOfCasesThisWeek',
    resizable: false
  },
  {
    Header: 'Last Week',
    accessor: d => Number(d.noOfCasesLastWeek),
    id: 'noOfCasesLastWeek',
    resizable: false
  },
  {
    Header: 'This Month',
    accessor: d => Number(d.noOfCasesThisMonth),
    id: 'noOfCasesThisMonth',
    resizable: false
  },
  {
    Header: 'This Year',
    accessor: d => Number(d.noOfCasesThisYear),
    id: 'noOfCasesThisYear',
    resizable: false
  },
  {
    Header: 'Last Case Created',
    accessor: d => d.lastCaseCreatedAt ? new Date(d.lastCaseCreatedAt).getTime() : 0,
    id: 'lastCaseCreatedAt',
    resizable: false,
    Cell: d => d.original.lastCaseCreatedAt ? new Date(d.original.lastCaseCreatedAt).toLocaleDateString('en-us') : '-'
  }];

const orgManagerLoginColumnDefs = [
  {
    headerName: 'Email',
    field: 'email',
  },
  {
    headerName: 'Name',
    valueGetter: (params) => {
      const first = params.data.firstName || ''
      const last = params.data.lastName || ''
      return `${first} ${last}`.trim()
    }
  },
  {
    headerName: '# Logins This Week',
    // field: 'noOfLoginsThisWeek',
    valueGetter: params => Number(params.data.noOfLoginsThisWeek),
  },
  {
    headerName: '# Logins Last Week',
    // field: 'noOfLoginsLastWeek',
    valueGetter: params => Number(params.data.noOfLoginsLastWeek),
  },
  {
    headerName: '# Logins This Month',
    // field: 'noOfLoginsThisMonth',
    valueGetter: params => Number(params.data.noOfLoginsThisMonth),
  },
  {
    headerName: '# Logins This Year',
    // field: 'noOfLoginsThisYear',
    valueGetter: params => Number(params.data.noOfLoginsThisYear),
  },
  {
    headerName: 'Active',
    field: 'lastLoginAt',
    valueGetter: (params) => UtilHelper.getReadableDuration(params.data.lastLoginAt) || '-',
    cellRenderer: (params) => {
      return params.data.enabled === false ? (
        <Tag color="error">Account Deactivated</Tag>
      ) : (
        UtilHelper.getReadableDuration(params.data.lastLoginAt) || '-'
      );
    },
  }
];

const orgManagerLoginColumns = [{Header: 'Email', accessor: 'email', resizable: false},
  {Header: 'First Name', accessor: 'firstName', resizable: false},
  {Header: 'Last Name', accessor: 'lastName', resizable: false},
  {
    Header: '# Logins This Week',
    accessor: d => Number(d.noOfLoginsThisWeek),
    id: 'noOfCasesThisWeek',
    resizable: false
  },
  {
    Header: '# Logins Last Week',
    accessor: d => Number(d.noOfLoginsLastWeek),
    id: 'noOfCasesLastWeek',
    resizable: false
  },
  {
    Header: '# Logins This Month',
    accessor: d => Number(d.noOfLoginsThisMonth),
    id: 'noOfCasesThisMonth',
    resizable: false
  },
  {
    Header: '# Logins This Year',
    accessor: d => Number(d.noOfLoginsThisYear),
    id: 'noOfCasesThisYear',
    resizable: false
  },
  {
    Header: 'Last Login At',
    accessor: d => d.lastLoginAt ? new Date(d.lastLoginAt).getTime() : 0,
    id: 'lastLoginAt',
    resizable: false,
    Cell: d => d.original.lastLoginAt ? new Date(parseInt(d.original.lastLoginAt)).toLocaleDateString('en-us') : '-'
  }];

class UserDashboard extends React.Component {

  getDashboardSummary = () => {
    this.setState({showLoader: true}, () => {
      this.props.getSummary().then((res) => {
        this.setState({
          totalUsers: res.totalUsers ?? 0,
          totalOrganizations: res.totalOrganizations ?? 0,
          totalCases: res.totalCases ?? 0,
          totalRevenue: res.totalRevenue ? UtilHelper.numberToCurrency(res.totalRevenue) : 0
        }, () => {
          this.getBillingSummary();
        });
      }, error => {
        this.setState({showLoader: false});
      });
    });
  };

  getDashboardAnalysis = () => {
    // const offset = this.state.pageIndex * this.state.pageSize;
    // const limit = this.state.pageSize;
    const offset = 0
    const limit = 100000
    this.setState({ showLoader: true })
    this.props.getAnalysis({ offset, limit }).then((res) => {
      if (this.props.currentRole.isSuperAdmin)
        this.setState({overallAnalysis: res, showLoader: false});
      else if (this.props.currentRole.isOrgManager)
        this.setState({organizationAnalysis: res, showLoader: false});
      else
        this.setState({analystAnalysis: res, showLoader: false});
    }, err => {
      this.setState({showLoader: false});
    });
  };


  getBillingSummary = () => {
    this.props.getBillingSummary().then((res) => {
      this.setState({billingInfo: res}, () => {
        this.getDashboardAnalysis();
      });
    }, err => {
      this.setState({showLoader: false});
    });
  };

  componentDidMount = () => {

    this.props.updatePageTitle(this.props.pageTitle, false);

    if (this.props.currentRole.isAnalyst) {
      this.getDashboardAnalysis();
    } else {
      this.getDashboardSummary();
    }
  };

  onReportChange = e => {
    this.setState({currentReport: e.target.value});
  };

  constructor(props) {
    super(props);

    this.dataGridRef = React.createRef();

    this.state = {
      totalUsers: 0,
      totalOrganizations: 0,
      totalCases: 0,
      totalRevenue: 0,
      showLoader: true,
      organizationAnalysis: [],
      overallAnalysis: { count:0, rows: [] },
      analystAnalysis: {},
      billingInfo: {},
      currentReport: 'cases',

      pageIndex: 0,
      pageSize: 10,
    };
  }

  downloadReport = () => {
    this.props.downloadSummaryReport().then((res) => {
      notification.show('info', 'Sumary Report', res.message);
    }, (err) => {
      notification.show('error', 'Sumary Report', 'Something went wrong. Please try again!');
    });
    // window.open(`${process.env.REACT_APP_SERVER_API_URL}${ACTIONS.DOWNLOAD_APPLICATION_SUMMARY_REPORT}`, '_blank').focus();
  };

  exportCSV = () => {
    const fileName = this.state.currentReport === 'cases' ?
    `cases-activity-${moment().format('DD-MM-YYYY')}.csv` :
    `login-activity-${moment().format('DD-MM-YYYY')}.csv`

    this.dataGridRef.current.api.exportDataAsCsv({
      fileName
    });
    notification.show('info', 'Data Exported');
  };

  handleSearch = (e) => {
    if (!this.dataGridRef?.current?.api) return
    const searchText = e.target.value
    this.dataGridRef.current.api.setQuickFilter(searchText);
  }

  formatTwoDigits = (num) => String(num).padStart(2, '0');

  render() {

    const {billingInfo, analystAnalysis} = this.state;

    return (
      <div>
        {
          this.props.currentRole.isSuperAdmin &&
          <div className="flex-vertical-gap-4">
            <div style={{ display: 'flex', justifyContent: "space-between" }}>
              <Typography.Title level={2} style={{ margin: 0 }}>Overview</Typography.Title>
              <Button onClick={this.exportCSV}>Export<CustomIcon name="Download" /></Button>
            </div>

            <Row gutter={[8, 8]}>
              <Col xs={24} sm={24} md={12} lg={6}>
                <SummaryCard
                  icon={<CustomIcon name="OpenFolder" width={48} height={48} color="#D65C5C" />}
                  title="Cases"
                  value={<Typography.Title level={0} style={{ margin: 0 }}>{this.formatTwoDigits(this.state.totalCases)}</Typography.Title>}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <SummaryCard
                  icon={<CustomIcon name="UserCircleSingle" width={48} height={48} color="#D65C5C" />}
                  title="Users"
                  value={<Typography.Title level={0} style={{ margin: 0 }}>{this.formatTwoDigits(this.state.totalUsers)}</Typography.Title>}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <SummaryCard
                  icon={<CustomIcon name="UserCircleSingle" width={48} height={48} color="#D65C5C" />}
                  title="Organizations"
                  value={<Typography.Title level={0} style={{ margin: 0 }}>{this.formatTwoDigits(this.state.totalOrganizations)}</Typography.Title>}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <SummaryCard
                  icon={<CustomIcon name="Billing" width={48} height={48} color="#D65C5C" />}
                  title="Revenue"
                  value={<Typography.Title level={0} style={{ margin: 0 }}>{this.formatTwoDigits(this.state.totalRevenue)}</Typography.Title>}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <SummaryCard
                  icon={<CustomIcon name="Billing" width={48} height={48} color="#D65C5C" />}
                  title="Billing"
                  value={<div className="flex-horizontal">
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ margin: 0 }}>{billingInfo.revenueLast1Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast1Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last Week</Typography.Text>
                    </div>
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ margin: 0 }}>{billingInfo.revenueLast4Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast4Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last 4 Weeks</Typography.Text>
                    </div>
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ margin: 0 }}>{billingInfo.revenueLast8Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast8Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last 8 Weeks</Typography.Text>
                    </div>
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ margin: 0 }}>{billingInfo.revenueLast12Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast12Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last 12 Weeks</Typography.Text>
                    </div>
                  </div>}
                />
              </Col>
            </Row>

            {/* <Row gutter={16}>
              <Col className="gutter-row" span={6}>
                <Card className="dashboard-card bg-green" onClick={() => window.open('/users', '_blank').focus()}>
                  <Col span={4}>
                    <div className="dashboard-image">
                      <i className="fa fa-user col-sm-2"></i>
                    </div>
                  </Col>
                  <Col span={20}>
                    <div className="dashboard-number text-right">
                      {this.state.totalUsers}
                    </div>
                    <div className="text-right">
                      Users
                    </div>
                  </Col>
                </Card>
              </Col>

              <Col className="gutter-row" span={6}>
                <Card className="dashboard-card bg-red" onClick={() => window.open('/organizations', '_blank').focus()}>
                  <Col span={4}>
                    <div className="dashboard-image">
                      <i className="fa fa-users col-sm-2"></i>
                    </div>
                  </Col>
                  <Col span={20}>
                    <div className="dashboard-number text-right">
                      {this.state.totalOrganizations}
                    </div>
                    <div className="text-right">
                      Organizations
                    </div>
                  </Col>
                </Card>
              </Col>

              <Col className="gutter-row" span={6}>
                <Card className="dashboard-card bg-blue" onClick={() => window.open('/cases', '_blank').focus()}>
                  <Col span={4}>
                    <div className="dashboard-image">
                      <i className="fa fa-briefcase col-sm-2"></i>
                    </div>
                  </Col>
                  <Col span={20}>
                    <div className="dashboard-number text-right">
                      {this.state.totalCases}
                    </div>
                    <div className="text-right">
                      Cases
                    </div>
                  </Col>
                </Card>
              </Col>

              <Col className="gutter-row" span={6}>
                <Card className="dashboard-card bg-yellow">
                  <Col span={4}>
                    <div className="dashboard-image">
                      <i className="fa fa-dollar col-sm-2"></i>
                    </div>
                  </Col>
                  <Col span={20}>
                    <div className="dashboard-number text-right">
                      {this.state.totalRevenue}
                    </div>
                    <div className="text-right">
                      Revenue
                    </div>
                  </Col>
                </Card>
              </Col>
            </Row> */}

            {/* <div className='dashboard-analysis'>
              <div className="dashboard-table-heading">Billing</div>

              <div className="dashboard-billing-container">
                <Row>
                  <Col span={12} className='billing-cell'>
                    Revenue Last Week
                  </Col>
                  <Col span={12} className='billing-cell'>
                    {billingInfo.revenueLast1Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast1Week) / 100)}` : '-'}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className='billing-cell'>
                    Revenue Last 4 Weeks
                  </Col>
                  <Col span={12} className='billing-cell'>
                    {billingInfo.revenueLast4Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast4Week) / 100)}` : '-'}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className='billing-cell'>
                    Revenue Last 8 Weeks
                  </Col>
                  <Col span={12} className='billing-cell'>
                    {billingInfo.revenueLast8Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast8Week) / 100)}` : '-'}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className='billing-cell last-billing-cell'>
                    Revenue Last 12 Weeks
                  </Col>
                  <Col span={12} className='billing-cell last-billing-cell'>
                    {billingInfo.revenueLast12Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast12Week) / 100)}` : '-'}
                  </Col>
                </Row>
              </div>
            </div> */}

            <div className="flex-vertical-gap-4">
              <Typography.Title level={3} style={{ margin: 0 }}>Activity</Typography.Title>
              <Input
                allowClear
                placeholder="Search"
                prefix={<CustomIcon name="Search" />}
                onChange={this.handleSearch}
              />
            </div>

            <DataGrid
              isLoading={this.state.showLoader}
              gridRef={this.dataGridRef}
              columnDefs={adminColumnDefs}
              rowData={this.state.overallAnalysis.rows}
            />

            {/* <ReactTable
              // defaultFilterMethod={UtilHelper.filterColumnReactTable}
              defaultPage={0}
              defaultPageSize={10}
              noDataText='No records present.'
              data={this.state.overallAnalysis.rows}
              columns={adminColumns}
              className="-striped -highlight"
              filterable={false}
              sortable={false}
              manual={true}
              pages={Math.ceil(this.state.overallAnalysis.count / this.state.pageSize)}
              page={this.state.pageIndex}
              pageSize={this.state.pageSize}
              resizable={false}
              onPageChange={(page) => {
                this.setState({ pageIndex: page }, () => {
                  this.getDashboardAnalysis();
                });
              }}
              onPageSizeChange={(size) => {
                this.setState({ pageIndex: 0, pageSize: size }, () => {
                  this.getDashboardAnalysis();
                });
              }}
              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (column.id === 'name') {
                      window.open(`/cases/${rowInfo.original.id}/list?${rowInfo.original.name}`, '_blank').focus();
                    }
                  }
                }
              }}
            /> */}

          </div>
        }

        {
          this.props.currentRole.isOrgManager &&
          <div className="flex-vertical-gap-4">
            <div style={{ display: 'flex', justifyContent: "space-between" }}>
              <Typography.Title level={2} style={{ margin: 0 }}>Overview</Typography.Title>
              <Button onClick={this.exportCSV}>Export<CustomIcon name="Download" /></Button>
            </div>

            <Row gutter={[8, 8]}>
              <Col xs={24} sm={24} md={12} lg={6}>
                <SummaryCard
                  icon={<CustomIcon name="OpenFolder" width={48} height={48} color="#D65C5C" />}
                  title="Cases"
                  value={<div className="gs-theme__h0">{this.formatTwoDigits(this.state.totalCases)}</div>}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <SummaryCard
                  icon={<CustomIcon name="UserCircleSingle" width={48} height={48} color="#D65C5C" />}
                  title="Users"
                  value={<div className="gs-theme__h0">{this.formatTwoDigits(this.state.totalUsers)}</div>}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <SummaryCard
                  icon={<CustomIcon name="Billing" width={48} height={48}  color="#D65C5C"/>}
                  title="Billing"
                  value={<div className="flex-horizontal">
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ marginBottom: 0 }}>{billingInfo.revenueLast1Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast1Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last Week</Typography.Text>
                    </div>
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ marginBottom: 0 }}>{billingInfo.revenueLast4Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast4Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last 4 Weeks</Typography.Text>
                    </div>
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ marginBottom: 0 }}>{billingInfo.revenueLast8Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast8Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last 8 Weeks</Typography.Text>
                    </div>
                    <div className="flex-vertical-gap-1" style={{ flex: 1 }}>
                      <Typography.Title level={1} style={{ marginBottom: 0 }}>{billingInfo.revenueLast12Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast12Week) / 100)}` : '$00'}</Typography.Title>
                      <Typography.Text type="secondary">Last 12 Weeks</Typography.Text>
                    </div>
                  </div>}
                />
              </Col>
            </Row>

            {/* <Row gutter={16}>
              <Col className="gutter-row" span={6}>
                <Card className="dashboard-card bg-green" onClick={() => window.open('/users', '_blank').focus() }>
                  <Col span={4}>
                    <div className="dashboard-image">
                      <i className="fa fa-user col-sm-2"></i>
                    </div>
                  </Col>
                  <Col span={20}>
                    <div className="dashboard-number text-right">
                      {this.state.totalUsers}
                    </div>
                    <div className="text-right">
                      Users
                    </div>
                  </Col>
                </Card>
              </Col>

              <Col className="gutter-row" span={6}>
                <Card className="dashboard-card bg-blue" onClick={() => window.open('/cases', '_blank').focus() }>
                  <Col span={4}>
                    <div className="dashboard-image">
                      <i className="fa fa-briefcase col-sm-2"></i>
                    </div>
                  </Col>
                  <Col span={20}>
                    <div className="dashboard-number text-right">
                      {this.state.totalCases}
                    </div>
                    <div className="text-right">
                      Cases
                    </div>
                  </Col>
                </Card>
              </Col>
            </Row> */}

            {/* <div className='dashboard-analysis'>
              <div className="dashboard-table-heading">Billing</div>

              <div className="dashboard-billing-container">
                <Row>
                  <Col span={12} className='billing-cell'>
                    Charges Last Week
                  </Col>
                  <Col span={12} className='billing-cell'>
                    {billingInfo.revenueLast1Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast1Week) / 100)}` : '-'}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className='billing-cell'>
                    Charges Last 4 Weeks
                  </Col>
                  <Col span={12} className='billing-cell'>
                    {billingInfo.revenueLast4Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast4Week) / 100)}` : '-'}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className='billing-cell'>
                    Charges Last 8 Weeks
                  </Col>
                  <Col span={12} className='billing-cell'>
                    {billingInfo.revenueLast8Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast8Week) / 100)}` : '-'}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className='billing-cell last-billing-cell'>
                    Charges Last 12 Weeks
                  </Col>
                  <Col span={12} className='billing-cell last-billing-cell'>
                    {billingInfo.revenueLast12Week ? `$${UtilHelper.numberToCurrency(parseFloat(billingInfo.revenueLast12Week) / 100)}` : '-'}
                  </Col>
                </Row>
              </div>
            </div> */}

            <Typography.Title level={3} style={{ margin: 0 }}>Activity</Typography.Title>
            <div className="flex-horizontal-gap-2">
              <Radio.Group style={{ display: 'flex' }} onChange={this.onReportChange} value={this.state.currentReport}>
                <Radio.Button value="cases" key="cases">Cases</Radio.Button>
                <Radio.Button value="logins" key="logins">Logins</Radio.Button>
              </Radio.Group>
              <Input
                allowClear
                placeholder="Search"
                prefix={<CustomIcon name="Search" />}
                onChange={this.handleSearch}
              />
            </div>
            {
              this.state.currentReport === 'cases'
                ?
                <DataGrid
                  isLoading={this.state.showLoader}
                  gridRef={this.dataGridRef}
                  columnDefs={orgManagerColumnDefs}
                  rowData={this.state.organizationAnalysis}
                />
                // <ReactTable
                //   defaultFilterMethod={UtilHelper.filterColumnReactTable}
                //   defaultPageSize={10}
                //   noDataText='No records present.'
                //   data={this.state.organizationAnalysis}
                //   columns={orgManagerColumns}
                // />
                :
                <DataGrid
                  isLoading={this.state.showLoader}
                  gridRef={this.dataGridRef}
                  columnDefs={orgManagerLoginColumnDefs}
                  rowData={this.state.organizationAnalysis}
                />
                // <ReactTable
                //   defaultFilterMethod={UtilHelper.filterColumnReactTable}
                //   defaultPageSize={10}
                //   noDataText='No records present.'
                //   data={this.state.organizationAnalysis}
                //   columns={orgManagerLoginColumns}
                // />
            }

          </div>
        }

        {
          this.props.currentRole.isAnalyst &&
          <>
          <div className='dashboard-analysis'>
            <div className="dashboard-table-heading">Analyst Statistics</div>

            <div className="dashboard-billing-container">
              <Row>
                <Col span={12} className='billing-cell'>
                  Total No of Cases
                </Col>
                <Col span={12} className='billing-cell'>
                  {analystAnalysis.totalNoOfCases ? analystAnalysis.totalNoOfCases : '-'}
                </Col>
              </Row>
              <Row>
                <Col span={12} className='billing-cell'>
                  No of Cases This Week
                </Col>
                <Col span={12} className='billing-cell'>
                  {analystAnalysis.noOfCasesThisWeek ? analystAnalysis.noOfCasesThisWeek : '-'}
                </Col>
              </Row>
              <Row>
                <Col span={12} className='billing-cell'>
                  No of Cases Last Week
                </Col>
                <Col span={12} className='billing-cell'>
                  {analystAnalysis.noOfCasesLastWeek ? analystAnalysis.noOfCasesLastWeek : '-'}
                </Col>
              </Row>
              <Row>
                <Col span={12} className='billing-cell last-billing-cell'>
                  No of Cases This Month
                </Col>
                <Col span={12} className='billing-cell last-billing-cell'>
                  {analystAnalysis.noOfCasesThisMonth ? analystAnalysis.noOfCasesThisMonth : '-'}
                </Col>
              </Row>
              <Row>
                <Col span={12} className='billing-cell last-billing-cell'>
                  No of Cases This Year
                </Col>
                <Col span={12} className='billing-cell last-billing-cell'>
                  {analystAnalysis.noOfCasesThisYear ? analystAnalysis.noOfCasesThisYear : '-'}
                </Col>
              </Row>
              <Row>
                <Col span={12} className='billing-cell last-billing-cell'>
                  Last case creation date
                </Col>
                <Col span={12} className='billing-cell last-billing-cell'>
                  {analystAnalysis.lastCaseCreatedAt ? new Date(analystAnalysis.lastCaseCreatedAt).toLocaleDateString('en-us') : '-'}
                </Col>
              </Row>
            </div>
          </div>
          </>
        }

        <GenaLoader showLoader={this.state.showLoader}/>

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updatePageTitle: (pageTitle, enablePageTitle) => {
      dispatch(setPageTitle(pageTitle, enablePageTitle));
    },

    getSummary: () => {
      return dispatch(getSummary()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });

    },

    getAnalysis: (params) => {
      return dispatch(getAnalysis(params)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });

    },

    getBillingSummary: () => {
      return dispatch(getBillingSummary()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });

    },

    downloadSummaryReport: () => {
      return dispatch(downloadSummaryReport()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });

    }
  }
};

UserDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDashboard);

export default UserDashboard;
